import { PRESETS } from './presets';

const KEY = 'mxc.devPreset';

/**
 * DEVELOPMENT ONLY. `?preset=street-bold` previews the storefront in another
 * preset; the choice sticks for the browser tab (sessionStorage) so links keep
 * it. `?preset=off` (or any unknown id) returns to the shop's own theme.
 *
 * In production builds this is replaced by a function that always returns
 * null, and the minifier drops the implementation: the shop's theme from the
 * API always wins.
 */
function readDevPresetImpl(search) {
  try {
    const param = new URLSearchParams(search).get('preset');
    if (param !== null) {
      if (PRESETS[param]) window.sessionStorage.setItem(KEY, param);
      else window.sessionStorage.removeItem(KEY);
    }
    const id = window.sessionStorage.getItem(KEY);
    return id && PRESETS[id] ? id : null;
  } catch {
    return null;
  }
}

export const readDevPreset =
  process.env.NODE_ENV !== 'production' ? readDevPresetImpl : () => null;
